import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IFinantialExpensesReport } from '../interfaces/finantial-expenses-report/ifinantial-expenses-report';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FinantialExpensesReportService {
 
  url: string = 'http://localhost:3000/finantial_expenses_report';

  /* url: string = 'https://api-fake-r9p5.onrender.com/exam'; */
  

  constructor(private http: HttpClient) { }

  get() {
    return this.http
      .get(this.url)
      .pipe(map((res: any) => res)) as Observable<IFinantialExpensesReport>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IEmployeeReport>;
  }

  getExpenses(filters: string){
    return this.http.get(`${environment.url}/report-expense${filters}`)
  }

  getLastThreeMonths(filters: string){
    return this.http.get(`${environment.url}/report-annual-expense${filters}`)
  }

  getTopFiveExpenses(filters: string){
    return this.http.get(`${environment.url}/report-top-five-expenses${filters}`)
  }

  getReportAnnualExpense(filters: string) {
    return this.http.get(`${environment.url}/report-annual-expense${filters}`)
  }

  getReportMonthToMonthExpense(filters: string) {
    return this.http.get(`${environment.url}/report-month-to-month-expense${filters}`)
  }

  getReportExpensesByCategoryMonthByMonth(filters: string) {
    return this.http.get(`${environment.url}/report-expenses-by-category-month-by-month${filters}`)
  }


}
